import routeService from '../service/route'
import Vue from 'vue'
const state = {
    routes: [],
    loading: false,
}

const actions = {
    getRoutes({ commit }) {
        commit('setLoading', true)
        routeService.getRoutes().then(routes => {
            commit('setRoutes', routes)
        }).catch((e) => {
            console.log(e)
            commit('setLoading', false)
        })
    },
    createRoute({ commit }, route) {
        commit('setLoading', true)
        routeService.createRoute(route)
            .then(res => {
                return routeService.getRoute(res._id);
            })
            .then(route => {
                commit('addRoute', route)
            }).catch((e) => {
                console.log(e)
                commit('setLoading', false)
            })
    },
    updateRoute({ commit }, route) {
        routeService.updateRoute(route).then(() => {
            return routeService.getRoute(route._id);
        }).then(newRoute => {
            commit('setRoute', newRoute);
        })
            .catch((e) => {
                console.log(e)
                commit('setLoading', false)
            })
    },
    deleteRoute({ commit }, routeId) {
        routeService.deleteRoute(routeId).then(() => {
            commit('removeRoute', routeId)
        }).catch((e) => {
            console.log(e)
            commit('setLoading', false)
        })

    }
}
const mutations = {
    setLoading(state, loading) {
        state.loading = loading
    },
    removeRoute(state, routeId) {
        const index = state.routes.findIndex(x => x._id == routeId)
        if (index != -1) {
            state.routes.splice(index, 1)
        }
        state.loading = false
    },
    setRoutes(state, routes) {
        state.routes = routes;
        state.loading = false
    },
    setRoute(state, route) {
        const index = state.routes.findIndex(x => x._id == route._id)
        if (index != -1) {
            Vue.set(state.routes, index, route)
            // state.routes[index] = route
        }
        state.loading = false

    },
    addRoute(state, route) {
        state.routes.push(route)
        state.loading = false

    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations
}



